import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TurfPlaceholder from '../../images/LandingPageBg2.png'; // Ensure the path is correct

const VenueCard = ({ turf }) => {
  const navigate = useNavigate();
  const [rating, setRating] = useState(turf.rating || 0);

  const handleClick = () => {
    navigate('/client', { state: { venueid: turf.venue_id } }); // Pass venueid to the client page
  };

  const handleRating = (newRating, e) => {
    e.stopPropagation(); // Prevent the click from triggering the card's onClick
    setRating(newRating);
  };

  const renderStars = () => {
    let stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span
          key={i}
          className={`star ${i <= rating ? 'filled' : 'empty'}`}
          onClick={(e) => handleRating(i, e)} // Pass the event here
          role="button"
          aria-label={`Rate ${i} out of 5 stars`}
        >★</span>
      );
    }
    return stars;
  };

  return (
    <div className="turf-card hover:scale-105 transition-transform duration-300 ease-in-out" onClick={handleClick}>
      <div className="price-tag">
        {turf.price_Range ? `₹${turf.price_Range}` : '₹ null'} {/* Changed $ to ₹ */}
      </div>
      <img
        src={turf.images && turf.images.length > 0 ? turf.images[0] : TurfPlaceholder}
        alt={turf.venue_name || 'Turf image'}
        className="turf-image transition-transform duration-300 ease-in-out hover:scale-110" // Zoom effect on hover
      />
      <div className="turf-info p-4 backdrop-blur-md bg-white/40 rounded-lg shadow-lg">
        <div className="turf-header">
          <h3 className="turf-name neon-text">{turf.venue_name || 'Unnamed Turf'}</h3>
          <span className="turf-location">{turf.area || 'Area not specified'}</span>
        </div>
        <div className="turf-footer mt-2">
          <div className="turf-rating">
            {renderStars()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenueCard;
